import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { EditorContext } from "./EditorContext";
import { Card } from "react-bootstrap";


export function MaterialSelectorModal<T extends {id: number, sampleImageUrl: string|null, name: string}>(props: {
    materials: T[],
    onClose: (() => void),
    onSelect: ((mat: T) => void),
    currentId?: number,
}) {

    const ec = useContext(EditorContext);

    
    return (
        <Modal onHide={props.onClose} show animation={false} centered scrollable size="lg" >
            <Modal.Header
                closeButton
                closeLabel={ec.translator("material-selector modal close label", "Luk")}>
                <Modal.Title>
                    {ec.translator("material-selector modal header", "Vælg materiale")}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row row-cols-1 row-cols-md-2">
                    {props.materials.map(mat => {
                        const border = mat.id === props.currentId
                            ? "primary"
                            : undefined;
                        return (
                            <div className="col mb-4" key={mat.id}>
                                <Card style={{ cursor: "pointer" }}
                                    onClick={() => props.onSelect(mat)}
                                    className="h-100"
                                    border={border}
                                >
                                    {mat.sampleImageUrl && <Card.Img src={mat.sampleImageUrl} style={{ height: "12em" }} />}
                                    <Card.Body>
                                        <Card.Title>
                                            {mat.name}
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </div>
                        )
                    }
                    )}
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="outline-secondary" onClick={props.onClose}>
                    {ec.translator("material-selector modal close button", "Luk")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
